var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileInformation = function SvgProfileInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M10 12.167c1.47 0 2.911.403 4.102 1.164 1.19.762 2.079 1.851 2.487 3.12a.833.833 0 0 1-1.587.51c-.276-.857-.894-1.647-1.798-2.226-.905-.579-2.032-.902-3.204-.902s-2.299.323-3.204.902c-.904.579-1.522 1.369-1.798 2.226a.834.834 0 0 1-1.587-.51c.408-1.269 1.296-2.358 2.487-3.12 1.19-.761 2.632-1.164 4.102-1.164"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    fillRule: "evenodd",
    d: "M10 2.167a4.833 4.833 0 1 1 0 9.665 4.833 4.833 0 0 1 0-9.665m0 1.666a3.167 3.167 0 1 0 0 6.335 3.167 3.167 0 0 0 0-6.335",
    clipRule: "evenodd"
  })));
};
export default SvgProfileInformation;